import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import '@/App.css';
import { AuthProvider } from './auth/AuthContext';
import { ProtectedRoute } from './components/shared/ProtectedRoute';
import { AppShell } from './components/shared/AppShell';
import { Toaster } from './components/ui/sonner';
import LoginPage from './pages/LoginPage';
import ForcedPasswordResetPage from './pages/ForcedPasswordResetPage';
import DashboardPage from './pages/DashboardPage';
import QuotesPage from './pages/QuotesPage';
import QuoteWizardPage from './pages/wizard/QuoteWizardPage';
import QuoteDetailPage from './pages/QuoteDetailPage';
import CustomersPage from './pages/CustomersPage';
import CustomerDetailPage from './pages/CustomerDetailPage';
import PartnerCreatePage from './pages/PartnerCreatePage';
import TenantsPage from './pages/TenantsPage';
import TenantDetailPage from './pages/TenantDetailPage';
import TenantCreatePage from './pages/TenantCreatePage';
import SigningPage from './pages/SigningPage';
import MtproSystemsPage from './pages/MtproSystemsPage';
import ReportsPage from './pages/ReportsPage';
import MtproSystemDetailPage from './pages/MtproSystemDetailPage';
import PricingGuide from './pages/admin/PricingGuide';
import ResourcesAdmin from './pages/admin/ResourcesAdmin';
import ResourceEditorPage from './pages/admin/ResourceEditorPage';
import ResourceGeneratorPage from './pages/admin/ResourceGeneratorPage';
import CrawlManagerPage from './pages/admin/CrawlManagerPage';
import ResourcesPage from './pages/ResourcesPage';
import ResourceDetailPage from './pages/ResourceDetailPage';

import ProfilePage from './pages/ProfilePage';

import AdminPage from './pages/admin/AdminPage';
import OrdersPage from './pages/OrdersPage';          // ContractsPage (file kept as OrdersPage.js)
import OrderDetailPage from './pages/OrderDetailPage'; // ContractDetailPage (file kept as OrderDetailPage.js)

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Toaster position="top-right" richColors expand={false} />
        <Routes>
          {/* Public routes - no auth required */}
          <Route path="/login" element={<LoginPage />} />
          <Route path="/sign/:token" element={<SigningPage />} />
          <Route path="/auth/reset-password" element={
            <ProtectedRoute><ForcedPasswordResetPage /></ProtectedRoute>
          } />
          <Route path="/*" element={
            <ProtectedRoute>
              <AppShell>
                <Routes>
                  <Route path="/" element={<Navigate to="/dashboard" replace />} />
                  <Route path="/dashboard" element={<DashboardPage />} />
                  <Route path="/quotes" element={<QuotesPage />} />
                  <Route path="/quotes/new" element={<QuoteWizardPage />} />
                  <Route path="/quotes/:id/edit" element={<QuoteWizardPage />} />
                  <Route path="/quotes/:id" element={<QuoteDetailPage />} />
                  <Route path="/orders" element={<OrdersPage />} />
                  <Route path="/orders/:id" element={<OrderDetailPage />} />
                  <Route path="/contracts" element={<OrdersPage />} />
                  <Route path="/contracts/:id" element={<OrderDetailPage />} />
                  <Route path="/customers" element={<CustomersPage />} />
                  <Route path="/customers/new" element={<PartnerCreatePage />} />
                  <Route path="/customers/:id" element={<CustomerDetailPage />} />
                  <Route path="/partners/new" element={<PartnerCreatePage />} />
                  <Route path="/tenants" element={<TenantsPage />} />
                  <Route path="/tenants/new" element={<TenantCreatePage />} />
                  <Route path="/tenants/:id" element={<TenantDetailPage />} />
                  <Route path="/reports" element={<ReportsPage />} />
                  <Route path="/mtpro-systems" element={<MtproSystemsPage />} />
                  <Route path="/mtpro-systems/:id" element={<MtproSystemDetailPage />} />
                  <Route path="/resources" element={<ResourcesPage />} />
                  <Route path="/resources/pricing-guide" element={<PricingGuide />} />
                  <Route path="/resources/:id" element={<ResourceDetailPage />} />
                  <Route path="/profile" element={<ProfilePage />} />
                  <Route path="/admin/*" element={<AdminPage />} />
                  <Route path="/admin/resources" element={<ResourcesAdmin />} />
                  <Route path="/admin/resources/new" element={<ResourceEditorPage />} />
                  <Route path="/admin/resources/:id/edit" element={<ResourceEditorPage />} />
                  <Route path="/admin/resource-generator" element={<ResourceGeneratorPage />} />
                  <Route path="/admin/crawl-manager" element={<CrawlManagerPage />} />
                  <Route path="*" element={<Navigate to="/dashboard" replace />} />
                </Routes>
              </AppShell>
            </ProtectedRoute>
          } />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
